import React from 'react';
import { Breadcrumb, Icon } from '@amzn/storm-ui';
import { ellipsisH } from '@amzn/storm-ui-icons';
import { EllipsisButton, VisibilityWrapper } from './style';

const TruncationIconLocal = React.memo(
  React.forwardRef<HTMLDivElement>((_, ref) => (
    <VisibilityWrapper ref={ref}>
      <Breadcrumb>
        <EllipsisButton>
          <Icon type={ellipsisH} size="lg" />
        </EllipsisButton>
      </Breadcrumb>
    </VisibilityWrapper>
  )),
);

// fix linting error
TruncationIconLocal.displayName = 'TruncationIcon';

export const TruncationIcon = TruncationIconLocal;
